import React, { Fragment } from 'react';
import '../LandingPageNYC/NYCVehicleTypes.css';
import AutzuEvMobileSF from './AutzuEvMobileSF';
import AutzuEvSF from './AutzuEvSF';

const SFVehicleTypes = ({ landing }) => (
  <div>
    <div className="nyc-vehicle-types">
      <div className="nyc-vehicle-types--container container">
        <div className="nyc-vehicle-types__container">
          <AutzuEvMobileSF />
        </div>
      </div>
    </div>
    <AutzuEvSF location={'sf'} />
  </div>
);

export default SFVehicleTypes;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/SFVehicleTypes.js